function Broadcast (props) {
    return (
        <>
        <div className="page-header">
                <div className="container-fluid d-sm-flex justify-content-between">
                    <h6>{props.title}</h6>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                کویر موتور
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">{props.title}</li>
                        </ol>
                    </nav>
                </div>
            </div>
        </>
    )
}

export default Broadcast;